import { Control, Controller } from "react-hook-form";

import { NamedInput } from "components/NamedInput/NamedInput";
import { VerticalSpace } from "components/VerticalSpace/VerticalSpace";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";
import { Checkbox2 } from "components/Checkbox2/Checkbox2";
import { Paragraph } from "components/Paragraph/Paragraph";

import styles from "./styles.module.scss";

type Props = {
  control: Control<any>;
  isEdit: boolean;
};

export const SalaryBody = ({ control, isEdit }: Props): JSX.Element => (
  <div className={styles.container}>
    <VerticalSpace size={19} />
    <div className="flex gap-x-8">
      <Controller
        name="name"
        control={control}
        render={({ field }) => (
          <NamedInput
            {...field}
            isRequired
            label="Название"
            placeholder="Зарплата"
            className={styles.name_input}
          />
        )}
      />
      {isEdit && (
        <Controller
          name="articleid"
          control={control}
          render={({ field }) => (
            <NamedInput
              {...field}
              disabled
              label="Код"
              placeholder="13"
              className={styles.code_input}
            />
          )}
        />
      )}
    </div>

    <VerticalSpace size={20} />

    <Controller
      name="position"
      control={control}
      render={({ field }) => (
        <NamedInput
          {...field}
          isRequired
          label="Позиция"
          placeholder="13"
          type="number"
          classNameContainer={styles.position}
          className={styles.position_input}
        />
      )}
    />
    <VerticalSpace size={20} />
    <div className="flex items-center">
      <Controller
        name="isTerminal"
        control={control}
        render={({ field }) => (
          <Checkbox2
            checked={field.value}
            onChange={() => {
              field.onChange(!field.value);
            }}
          />
        )}
      />

      <HorizontalSpace size={12} />
      <Paragraph>Доступно в терминале</Paragraph>
    </div>
  </div>
);
